import { SearchComponent } from './../components/search/search.component'
import { PreviewMapModule } from '@components/preview-map/preview-map.module'
import { ChipModule } from '@components/chip/chip.module'
import { NgxPermissionsModule } from 'ngx-permissions'
import { ProgressbarModule } from '@components/progressbar/progressbar.module'
import { SubIndustriesModule } from '@components/sub-industries/sub-industries.module'
import { PropertyInvoiceModule } from '@components/property-invoice/property-invoice.module'
import { MeasureMapModule } from '@components/measure-map/measure-map.module'
import { FormRowModule } from '@components/form-row/form-row.module'
import { PropertyTabsModule } from '@components/property-tabs/property-tabs.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { TableModule } from '@components/table/table.module'
import { NgSelectModule } from '@ng-select/ng-select'
import { CookieService } from 'ngx-cookie-service'
import {
  ListToStringPipe,
  ArrayPipe,
  MapToStringPipe,
  CountdownPipe,
  KeyToTextPipe,
  FormatDate,
  IntegerPipe,
} from './shared.pipe'
import { FormBuilderModule } from '../components/form-builder/form-builder.module'
import { TagInputModule } from 'ngx-chips'
import { TooltipModule } from 'ng2-tooltip-directive'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { BusinessSubcategoriesModule } from '@components/business-subcategories/business-subcategories.module'
import { BusinessSubcategorySlotsModule } from '@components/business-subcategory-slots/business-subcategory-slots.module'
import { ColorPickerComponent } from '@components/color-picker/color-picker.component'
import { AccordionComponent } from '@components/accordion/accordion.component'
import { AuthService } from '@containers/auth/auth.service'
import { PageHeaderModule } from '@components/page-header/page-header.module'
import { PanelModule } from '@components/panel/panel.module'
import { CardModule } from '@components/card/card.module'
import { TabsetModule } from '@components/tabset/tabset.module'
import { NumberInputModule } from '@components/number-input/number-input.module'
import { AlertModule } from './components/alert/alert.module'

@NgModule({
  declarations: [
    ListToStringPipe,
    CountdownPipe,
    ArrayPipe,
    IntegerPipe,
    KeyToTextPipe,
    SearchComponent,
    FormatDate,
    ColorPickerComponent,
    AccordionComponent,
  ],
  imports: [
    NgSelectModule,
    NgxPermissionsModule.forRoot(),
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    TableModule,
    FormBuilderModule,
    PropertyTabsModule,
    TagInputModule,
    FormRowModule,
    MeasureMapModule,
    PropertyInvoiceModule,
    SubIndustriesModule,
    ProgressbarModule,
    ReactiveFormsModule,
    ChipModule,
    PreviewMapModule,
    TooltipModule,
    TranslateModule,
    ContentEditableModule,
    BusinessSubcategoriesModule,
    BusinessSubcategorySlotsModule,
    PageHeaderModule,
    PanelModule,
    CardModule,
    TabsetModule,
    NumberInputModule,
    AlertModule,
  ],
  providers: [CookieService, AuthService],
  exports: [
    NumberInputModule,
    NgxPermissionsModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    NgSelectModule,
    TableModule,
    ArrayPipe,
    IntegerPipe,
    KeyToTextPipe,
    ListToStringPipe,
    CountdownPipe,
    FormBuilderModule,
    PropertyTabsModule,
    TagInputModule,
    FormRowModule,
    MeasureMapModule,
    PropertyInvoiceModule,
    SubIndustriesModule,
    ProgressbarModule,
    ReactiveFormsModule,
    ChipModule,
    PreviewMapModule,
    TooltipModule,
    SearchComponent,
    TranslateModule,
    ContentEditableModule,
    BusinessSubcategoriesModule,
    BusinessSubcategorySlotsModule,
    FormatDate,
    ColorPickerComponent,
    AccordionComponent,
    PageHeaderModule,
    PanelModule,
    CardModule,
    TabsetModule,
    AlertModule,
  ],
})
export class SharedModule {}
